const doc = [({"en":({"reLinking":"Re-interlocking is required to renew the public token."}), "ko":({"reLinking":"Public token 갱신을 위해서 재연동이 필요합니다."})})];
module.exports = doc.length <= 1 ? doc[0] : doc;